import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'


export const RestrictedArea=()=> {
  return (
    <>
    <MainDiv>
    <MainContent/>
    </MainDiv>
    </>
    
  )
}
